import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  mode : 'history',
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      component: () => import('../components/Home.vue'),
      // component: () => import('../components/program/VideoMain.vue'),
      meta: { title: '首页', requireAuth: false, manageAuth: false},
    },
    {
      path: '/macquarie',
      component: () => import('../components/website/Macquarie.vue'),
      meta: { title: '麦考瑞课程', requireAuth: false, manageAuth: false},
    },
    {
      path: '/accounting',
      component: () => import('../components/website/Accounting.vue'),
      meta: { title: '会计实战课程', requireAuth: false, manageAuth: false},
    },
    {
      path: '/CFA',
      component: () => import('../components/website/CFAProgram.vue'),
      meta: { title: 'CFA Program课程', requireAuth: false, manageAuth: false},
    },
    {
      path: '/CPA',
      component: () => import('../components/website/CPA.vue'),
      meta: { title: '澳洲CPA课程', requireAuth: false, manageAuth: false},
    },
    {
      path: '/G5',
      component: () => import('../components/website/G5.vue'),
      meta: { title: '藤校/G5直推班', requireAuth: false, manageAuth: false},
    },
    {
      path: '/holloway',
      component: () => import('../components/website/Holloway.vue'),
      meta: { title: '英国皇家霍洛威', requireAuth: false, manageAuth: false},
    },
    {
      path: '/IELTS',
      component: () => import('../components/website/IELTS.vue'),
      meta: { title: '雅思托福保过班', requireAuth: false, manageAuth: false},
    },
    {
      path: '/kingsLondon',
      component: () => import('../components/website/KingsLondon.vue'),
      meta: { title: '英国伦敦国王学院', requireAuth: false, manageAuth: false},
    },
    {
      path: '/manchester',
      component: () => import('../components/website/Manchester.vue'),
      meta: { title: '曼彻斯特大学', requireAuth: false, manageAuth: false},
    },
    {
      path: '/monash',
      component: () => import('../components/website/Monash.vue'),
      meta: { title: 'Monash课程', requireAuth: false, manageAuth: false},
    },
    {
      path: '/PTE',
      component: () => import('../components/website/PTE.vue'),
      meta: { title: 'PTE语言培训', requireAuth: false, manageAuth: false},
    },
    {
      path: '/UNSW',
      component: () => import('../components/website/UNSW.vue'),
      meta: { title: 'UNSW和USYD', requireAuth: false, manageAuth: false},
    },
    {
      path: '/aboutUs',
      component: () => import('../components/website/AboutUs.vue'),
      meta: { title: '关于我们', requireAuth: false, manageAuth: false},
    },
    {
      path: '/transfer',
      component: () => import('../components/website/Transfer.vue'),
      meta: { title: '升学转学', requireAuth: false, manageAuth: false},
    },
    {
      path: '/ivyLeague',
      component: () => import('../components/website/IvyLeague.vue'),
      meta: { title: '美国藤校/英国G5保录', requireAuth: false, manageAuth: false},
    },
    {
      path: '/induction',
      component: () => import('../components/website/Induction.vue'),
      meta: { title: '实习全职', requireAuth: false, manageAuth: false},
    },
    {
      path: '/auNews',
      component: () => import('../components/website/AuNews.vue'),
      meta: { title: '澳洲校区新闻', requireAuth: false, manageAuth: false},
    },
    {
      path: '/enNews',
      component: () => import('../components/website/EnNews.vue'),
      meta: { title: '英国校区新闻', requireAuth: false, manageAuth: false},
    },
    {
      path: '/news/:id',
      component: () => import('../components/website/NewsDetail.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/team',
      component: () => import('../components/website/Team.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    // {
    //   path: '/',
    //   component: () => import('../components/program/VideoMain.vue'),
    //   meta: { title: '课程首页', requireAuth: false, manageAuth: false},
    // },
    {
      path: '/course',
      component: () => import('../components/program/VideoMain.vue'),
      meta: { title: '课程首页', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/login',
        component: () => import('../components/Login.vue'),
      meta: { title: '课程首页', requireAuth: false, manageAuth: false},
    },
    // {
    //   path: '/course/login',
    //   component: () => import('../components/program/WechatLogin.vue'),
    //   meta: { title: '课程首页', requireAuth: false, manageAuth: false},
    // },
    {
      path: '/course/VideoSearch/:searchMsg',
      component: () => import('../components/program/VideoSearch.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/VideoSearch/',
      component: () => import('../components/program/VideoSearch.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/VideoSearchType/:id',
      component: () => import('../components/program/VideoSearch.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/VideoSearchType/',
      component: () => import('../components/program/VideoSearch.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/videoDetail/:id',
      component: () => import('../components/program/VideoDetail.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/videoPlay/:id',
      component: () => import('../components/program/VideoPlay.vue'),
      meta: { title: '课程搜索', requireAuth: false, manageAuth: false},
    },
    {
      path: '/course/bindLogin/:openid',
      component: () => import(/* webpackChunkName: "login" */ '../components/Login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/manage/login',
      component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
      meta: { title: '登录' }
    },
    {
      path: '/manage',
      component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
      meta: { title: '自述文件', requireAuth: true, manageAuth: true},
      children: [
        {
          path: '/manage/dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
          meta: { title: '系统首页' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/userManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/UserManage.vue'),
          meta: { title: '用户管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/videoManage',
            component: () => import(/* webpackChunkName: "table" */ '../components/page/VideoManage.vue'),
          meta: { title: '视频管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/videoTypeManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/videoTypeManage.vue'),
          meta: { title: '视频类型管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/videoDetailManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/VideoDetailManage.vue'),
          meta: { title: '视频统计管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/teacherManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/TeacherManage.vue'),
          meta: { title: '老师简介管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/VideoTypeTeacManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/VideoTypeTeacManage.vue'),
          meta: { title: '视频类型管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/errorLog',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/ErrorLog.vue'),
          meta: { title: '日志信息' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/videoUpload',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/VideoUpload.vue'),
          meta: { title: '视频上传' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/studentPraise',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/StudentPraise.vue'),
          meta: { title: '学员褒奖管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/feedback',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/Feedback.vue'),
          meta: { title: '学员反馈管理' , requireAuth: true, manageAuth: true}
        },
        {
          path: '/manage/teamManage',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/TeamManage.vue'),
          meta: { title: '教师团队管理' , requireAuth: true, manageAuth: true}
        },
        {
          // 富文本编辑器组件
          path: '/manage/editor',
          component: () => import(/* webpackChunkName: "editor" */ '../components/page/VueEditor.vue'),
          meta: { title: '富文本编辑器' }
        },
        {
          // 富文本编辑器组件
          path: '/manage/articleManage',
          component: () => import(/* webpackChunkName: "editor" */ '../components/page/ArticleManage.vue'),
          meta: { title: '文章管理' }
        },
        {
          path: '/icon',
          component: () => import(/* webpackChunkName: "icon" */ '../components/page/Icon.vue'),
          meta: { title: '自定义图标' }
        },
        {
          path: '/table',
          component: () => import(/* webpackChunkName: "table" */ '../components/page/BaseTable.vue'),
          meta: { title: '基础表格' }
        },
        {
          path: '/tabs',
          component: () => import(/* webpackChunkName: "tabs" */ '../components/page/Tabs.vue'),
          meta: { title: 'tab选项卡' }
        },
        {
          path: '/form',
          component: () => import(/* webpackChunkName: "form" */ '../components/page/BaseForm.vue'),
          meta: { title: '基本表单' }
        },

        {
          // markdown组件
          path: '/manage/markdown',
          component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Markdown.vue'),
          meta: { title: 'markdown编辑器' }
        },
        {
          // 图片上传组件
          path: '/UploadVideo',
          component: () => import(/* webpackChunkName: "upload" */ '../components/page/UploadVideo.vue'),
          meta: { title: '文件上传' }
        },
        {
          // 图片上传组件
          path: '/upload',
          component: () => import(/* webpackChunkName: "upload" */ '../components/page/Upload.vue'),
          meta: { title: '文件上传' }
        },
        {
          // vue-schart组件
          path: '/charts',
          component: () => import(/* webpackChunkName: "chart" */ '../components/page/BaseCharts.vue'),
          meta: { title: 'schart图表' }
        },
        {
          // 拖拽列表组件
          path: '/drag',
          component: () => import(/* webpackChunkName: "drag" */ '../components/page/DragList.vue'),
          meta: { title: '拖拽列表' }
        },
        {
          // 拖拽Dialog组件
          path: '/dialog',
          component: () => import(/* webpackChunkName: "dragdialog" */ '../components/page/DragDialog.vue'),
          meta: { title: '拖拽弹框' }
        },
        {
          // 国际化组件
          path: '/i18n',
          component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
          meta: { title: '国际化' }
        },
        {
          // 权限页面
          path: '/permission',
          component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
          meta: { title: '权限测试', permission: true }
        },

        {
          path: '/donate',
          component: () => import(/* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
          meta: { title: '支持作者' }
        },
        {
          path: '*',
          redirect: '/404'
        }
      ]
    },
    {
      path: '/wechat/wxCodeRedirect',
      redirect: '/'
    },
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
      meta: { title: '404' }
    },
    {
      path: '/403',
      component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
      meta: { title: '403' }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js